import React, { FC } from "react";

import { Stack } from "@mui/material";
import {
  screenSizeLgMax as _screenSizeLgMax,
  screenSizeXlMax as _screenSizeXlMax,
} from "@src/utils";

interface Props {
  children: JSX.Element | string | undefined | React.ReactNode;
  removeXPadding?: boolean;
  screenSizeXlMax?: number;
  removeXPaddingXs?: boolean;
}

const LayoutTwentyFour: FC<Props> = ({
  children,
  screenSizeXlMax = _screenSizeXlMax,
  removeXPadding = false,

  // In some circumstances we need more granular control
  removeXPaddingXs = false,
}) => {
  return (
    <Stack
      sx={{
        width: "100%",
        maxWidth: {
          xs: `100%`,
          xl: `${screenSizeXlMax}px`,
        },
        margin: "0 auto",
        position: "relative",
      }}
    >
      <Stack
        sx={{
          width: "100%",
          paddingX: {
            xs: !removeXPadding ? (!removeXPaddingXs ? "16px" : "0px") : "0px",
            sm: !removeXPadding ? "32px" : "0px",
            md: !removeXPadding ? "64px" : "0px",
            lg: !removeXPadding ? "80px" : "0px",
            xl: !removeXPadding ? "112px" : "0px",
          },
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default LayoutTwentyFour;
